<template>
    <div class="flex-fill">
        <div style="color: #616161; font-size: 0.85rem">
            <div :key="element.id" v-for="element in listData" class=" px-1">
                <el-card class="mb-1 mt-1" :body-style="{ padding: '0.6rem 0.8rem' }">
                    <div class="d-flex">
                        <div class="flex-fill">
                            <div>
                                <div v-if="element.billId" class="text-primary">
                                    {{ element.billId }}
                                </div>
                                <div v-else style="color: #bdbdbd">-- -- -- -- -- -- --</div>
                            </div>
                            <div >
                                <div class="text-muted" style="font-size: 90%;">
                                    <i class="text-muted ri-computer-line mr-1"></i>{{ element.machineId }} - {{ element.machineName }}
                                </div>
                                <div class="text-muted" style="font-size: 90%;">
                                    <i class="ri-archive-line mr-1"></i>{{ element.packageName }}
                                </div>
                            </div>
                            <div style="font-size: 90%;">
                                <div class="d-flex align-items-center">
                                    <svg width="14" height="14" viewBox="0 0 12 12" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5 3.984C4.54542 4.20953 4.18043 4.58211 3.96429 5.04124C3.74816 5.50036 3.69357 6.01906 3.80939 6.51312C3.92522 7.00718 4.20465 7.44758 4.60233 7.7628C5 8.07802 5.49255 8.24956 6 8.24956C6.50745 8.24956 7.00001 8.07802 7.39768 7.7628C7.79535 7.44758 8.07478 7.00718 8.19061 6.51312C8.30643 6.01906 8.25185 5.50036 8.03571 5.04124C7.81957 4.58211 7.45458 4.20953 7 3.984M6 3.25V5.5M10.25 6C10.25 8.34721 8.34721 10.25 6 10.25C3.65279 10.25 1.75 8.34721 1.75 6C1.75 3.65279 3.65279 1.75 6 1.75C8.34721 1.75 10.25 3.65279 10.25 6Z"
                                            stroke="#19B5FE" stroke-width="0.7" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span class="ml-1 text-muted">{{ element.startTime | pretyDateUtcToLocal }}</span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <svg width="14" height="14" viewBox="0 0 12 12" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5 3.984C4.54542 4.20953 4.18043 4.58211 3.96429 5.04124C3.74816 5.50036 3.69357 6.01906 3.80939 6.51312C3.92522 7.00718 4.20465 7.44758 4.60233 7.7628C5 8.07802 5.49255 8.24956 6 8.24956C6.50745 8.24956 7.00001 8.07802 7.39768 7.7628C7.79535 7.44758 8.07478 7.00718 8.19061 6.51312C8.30643 6.01906 8.25185 5.50036 8.03571 5.04124C7.81957 4.58211 7.45458 4.20953 7 3.984M6 3.25V5.5M10.25 6C10.25 8.34721 8.34721 10.25 6 10.25C3.65279 10.25 1.75 8.34721 1.75 6C1.75 3.65279 3.65279 1.75 6 1.75C8.34721 1.75 10.25 3.65279 10.25 6Z"
                                            stroke="#DF4F4F" stroke-width="0.7" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span class="ml-1 text-muted">{{ element.endTime | pretyDateUtcToLocal }}</span>
                                </div>
                            </div>
                        </div>
                        <div style="align-self: flex-end;font-size: 90%;">
                            <div>
                                <span class="ml-1  justify-content-end d-flex align-items-center">
                                    <span class="text-muted me-2">Rate</span>
                                    <strong style="color: #ED8A34;">{{ element.percentRate }}%</strong>
                                </span>
                            </div>
                            <div>
                                <span class="ml-1  justify-content-end d-flex align-items-center">
                                    <span class="text-muted me-2">Spent</span>
                                    <strong style="color: #ED8A34;">-{{ element.spentAmount | roundedMoney }}</strong>
                                    <ir-point class="ms-1" color="#ED8A34" size="10px" />
                                </span>
                            </div>
                            <div>
                                <span class="ml-1  justify-content-end d-flex align-items-center">
                                    <span style="" class="text-muted me-2">Credit back</span>
                                    <strong style="color: #529420;">+{{ element.cashbackAmount | roundedMoney
                                        }}</strong>
                                    <ir-point class="ms-1" color="#529420" size="10px" />
                                </span>
                            </div>
                           <div>
                                <span class="ml-1 justify-content-end d-flex align-items-center text-primary">
                                    <span class="text-muted me-2">Main BAL</span>
                                    <strong>{{ element.mainBalance | roundedMoney }}</strong>
                                    <ir-point class="ms-1 text-primary" size="10px" />
                                </span>
                            </div>
                            <div>
                                <span class="ml-1  justify-content-end d-flex align-items-center">
                                    <span class="text-muted me-2">Extra BAL</span>
                                    <strong style="color: #529420;">{{ element.extraBalance | roundedMoney }}</strong>
                                    <ir-point class="ms-1" color="#529420" size="10px" />
                                </span>
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        listData: {
            type: Array,
            default() {
                return []
            }
        },
        dict: {
            type: Object,
            default() {
                return {}
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    }
}
</script>